// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__213sq","languageWrap":"style_languageWrap__1hsMi"};